import styled from "styled-components";

import { BOOKING_SUMMARY_SPACE_KEEPER_HEIGHT } from "@config/consts";

import { rem, text } from "@ui/helpers";
import {
  Skeleton,
  SummaryList,
  SummaryVouchers,
  SummaryVouchersValue,
} from "@ui/Atoms";
import { Box } from "@ui/Molecules/Box";
import { PriceSubparts } from "@ui/Molecules/PriceSubparts";
import { CleaningProductsSummary } from "@ui/Organisms/CleaningProductsSummary";

const BookingSummarySpaceKeeper = styled.div`
  height: ${rem(BOOKING_SUMMARY_SPACE_KEEPER_HEIGHT)};
  ${props => props.theme.breakpoints.desktop} {
    display: none;
  }
`;

const SummaryWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 1fr auto;
  gap: 0px 0px;
  grid-template-areas:
    "left right"
    "bottom bottom";

  ${props => props.theme.breakpoints.desktop} {
    display: block;
  }
`;

const SummaryListStyled = styled(SummaryList)`
  svg {
    margin: -5px calc(${props => props.theme.margins.base_x2} - 5px) -5px -5px;
  }

  > li:last-of-type {
    padding-bottom: 0;
  }
`;

const SummaryListItem = styled.li`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

const PricePerHour = styled.div`
  flex-direction: column;
  display: flex;
  position: relative;
`;

const VatInfo = styled.div`
  font-size: ${props => props.theme.fonts.sizes.overline};
  line-height: ${props => props.theme.fonts.lineHeights.overline};
  color: ${props => props.theme.palette.grey600};
  text-align: right;
`;

const PricePerHourSkeleton = styled(Skeleton)`
  position: absolute;
  inset: 0;
  min-height: auto;
`;

const PricePerHourSkeletonWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  background-color: ${props => props.theme.palette.white};
  min-width: ${rem(80)};
  width: 100%;
  height: 100%;
`;

const MobilePeriodicityContainer = styled.div`
  justify-content: space-between;
  display: flex;
  gap: ${props => props.theme.margins.base_x2};
`;

const ExtraItem = styled.div`
  margin-left: ${props => props.theme.margins.base_x5};

  &:first-of-type {
    margin-top: ${props => props.theme.margins.base};
  }
`;

const HomeCleaningType = styled.li`
  display: flex;
  justify-content: space-between;
`;

const HomeCleaningLabel = styled.div`
  flex: 1 0 auto;
`;

const HomeCleaningPriceWrapper = styled.div`
  position: relative;
  height: 0;
`;

const HomeCleaningPrice = styled.div`
  line-height: ${rem(21)};
  text-align: right;
`;

const HomeCleaningPriceCaption = styled.div`
  font-size: ${props => props.theme.fonts.sizes.caption};
  font-weight: ${props => props.theme.fonts.weights.normal};
  line-height: ${props => props.theme.fonts.lineHeights.caption};
`;

const DesktopSummaryCleaningProducts = styled(CleaningProductsSummary)`
  li {
    margin-bottom: ${props => props.theme.margins.base};
  }
`;

const MobileSummaryCleaningProducts = styled(CleaningProductsSummary)`
  > li {
    margin-bottom: ${props => props.theme.margins.base_x2};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const MobileSummaryHomeCleaningPriceWrapper = styled(HomeCleaningPriceWrapper)<{
  hasExtras?: boolean;
}>`
  height: ${props => (props.hasExtras ? "auto" : 0)};
  padding: 0 ${props => props.theme.margins.base}
    ${props => props.theme.margins.base};
  float: right;
`;

const StyledSummaryVouchers = styled(SummaryVouchers)`
  margin-right: ${props => props.theme.margins.base_x2};

  ${SummaryVouchersValue} {
    font-size: ${props => props.theme.fonts.sizes.body};
    line-height: 1;
  }
`;

const StyledBox = styled(Box)`
  ${text("regular_16")}
  padding-bottom: ${props => props.theme.margins.base_x3};
  border: 1px solid ${props => props.theme.palette.grey800};
  border-radius: 12px;

  ${props => props.theme.breakpoints.desktopLarge} {
    ${text("regular_18")}
  }
`;

const StyledPriceSubpartsList = styled(PriceSubparts.List)`
  margin-bottom: ${props => props.theme.margins.base_x1_5};

  /* Because of this @ui/Atoms/Section/Section.tsx:57 */
  > li {
    margin-bottom: 0;
  }
`;

export {
  BookingSummarySpaceKeeper,
  SummaryWrapper,
  SummaryListStyled,
  ExtraItem,
  HomeCleaningType,
  HomeCleaningLabel,
  HomeCleaningPriceWrapper,
  HomeCleaningPrice,
  HomeCleaningPriceCaption,
  DesktopSummaryCleaningProducts,
  MobileSummaryCleaningProducts,
  MobileSummaryHomeCleaningPriceWrapper,
  StyledSummaryVouchers,
  StyledBox,
  StyledPriceSubpartsList,
  PricePerHour,
  VatInfo,
  PricePerHourSkeleton,
  PricePerHourSkeletonWrapper,
  MobilePeriodicityContainer,
  SummaryListItem,
};
